// API Configuration
export const API_BASE_URL = process.env.REACT_APP_API_URL || (process.env.NODE_ENV === 'development' ? 'http://localhost:5000/api' : '');
// Clean API Base URL (without /api suffix for file uploads)
export const CLEAN_API_BASE_URL = process.env.REACT_APP_API_URL || (process.env.NODE_ENV === 'development' ? 'http://localhost:5000/api' : '');

// API Endpoints
export const API_ENDPOINTS = {
  // Auth endpoints
  AUTH: {
    REGISTER: '/auth/register',
    LOGIN: '/auth/login',
    LOGOUT: '/auth/logout',
    ME: '/auth/me',
    PROFILE: '/auth/profile',
    CHANGE_PASSWORD: '/auth/change-password'
  },
  
  // Villa/Property endpoints
  PROPERTIES: {
    BASE: '/properties',
    FEATURED: '/properties/featured',
    CATEGORY: '/properties/category',
    LOCATION: '/properties/location',
    SEARCH: '/properties/search',
    CATEGORIES: '/properties/categories',
    LOCATIONS: '/properties/locations',
    FACILITIES: '/properties/facilities',
    IMAGES: '/properties/images',
    STATUS: '/properties/status',
    TOGGLE_FEATURED: '/properties/featured'
  },
  
  // Business Package endpoints
  BUSINESS: {
    BASE: '/business-packages',
    FEATURED: '/business-packages/featured',
    TYPE: '/business-packages/type'
  },
  
  // Service endpoints
  SERVICES: {
    BASE: '/services',
    FEATURED: '/services/featured',
    TYPE: '/services/type'
  },
  
  // Contact endpoints
  CONTACTS: {
    BASE: '/contacts',
    STATUS: '/contacts/status',
    NEW_COUNT: '/contacts/new/count',
    READ: '/contacts/read'
  },
  
  // Company endpoints
  COMPANY: {
    PROFILE: '/company/profile',
    CEO: '/company/ceo',
    CONTACT: '/company/contact'
  }
};

// User Roles
export const USER_ROLES = {
  ADMIN: 'admin',
  STAFF: 'staff',
  USER: 'user'
};

// Property/Villa Status
export const PROPERTY_STATUS = {
  ACTIVE: 'active',
  INACTIVE: 'inactive',
  MAINTENANCE: 'maintenance',
  SOLD: 'sold'
};

// Business Package Types
export const PACKAGE_TYPES = {
  BASIC: 'basic',
  PREMIUM: 'premium',
  ENTERPRISE: 'enterprise'
};

// Service Types
export const SERVICE_TYPES = {
  MANAGEMENT: 'management',
  CONSULTING: 'consulting',
  MAINTENANCE: 'maintenance',
  MARKETING: 'marketing',
  RENTAL: 'rental',
  TRANSPORTATION: 'transportation',
  TOUR: 'tour',
  ATTRACTION: 'attraction'
};

// Contact Message Status
export const CONTACT_STATUS = {
  NEW: 'new',
  READ: 'read',
  REPLIED: 'replied',
  CLOSED: 'closed'
};

// General Status
export const GENERAL_STATUS = {
  ACTIVE: 'active',
  INACTIVE: 'inactive'
};

// Pagination
export const PAGINATION = {
  DEFAULT_LIMIT: 10,
  DEFAULT_PAGE: 1,
  LIMITS: [5, 10, 25, 50, 100]
};

// File Upload
export const FILE_UPLOAD = {
  MAX_SIZE: 5 * 1024 * 1024, // 5MB
  ALLOWED_TYPES: {
    IMAGES: ['image/jpeg', 'image/jpg', 'image/png', 'image/gif', 'image/webp'],
    DOCUMENTS: ['application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document']
  },
  MAX_IMAGES_PER_PROPERTY: 10
};

// Form Validation
export const VALIDATION = {
  EMAIL_REGEX: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
  PHONE_REGEX: /^[\d\-\+\(\)\s]+$/,
  PASSWORD_MIN_LENGTH: 6,
  NAME_MIN_LENGTH: 2,
  NAME_MAX_LENGTH: 100,
  DESCRIPTION_MAX_LENGTH: 2000,
  TITLE_MAX_LENGTH: 200
};

// Currency
export const CURRENCY = {
  IDR: 'IDR',
  USD: 'USD',
  SYMBOLS: {
    IDR: 'Rp',
    USD: '$'
  }
};

// Date Formats
export const DATE_FORMATS = {
  DISPLAY: 'dd/MM/yyyy',
  DISPLAY_WITH_TIME: 'dd/MM/yyyy HH:mm',
  API: 'yyyy-MM-dd',
  API_WITH_TIME: 'yyyy-MM-dd HH:mm:ss'
};

// Storage Keys
export const STORAGE_KEYS = {
  AUTH_TOKEN: 'villa_management_token',
  USER_DATA: 'villa_management_user',
  THEME: 'villa_management_theme',
  LANGUAGE: 'villa_management_language',
  REMEMBER_ME: 'villa_management_remember'
};

// Theme
export const THEMES = {
  LIGHT: 'light',
  DARK: 'dark'
};

// Languages
export const LANGUAGES = {
  ID: 'id',
  EN: 'en'
};

// Navigation Menu Items
export const MENU_ITEMS = {
  PUBLIC: [
    { name: 'Beranda', path: '/', key: 'home' },
    { name: 'Villa', path: '/villas', key: 'villas' },
    { name: 'Bisnis', path: '/business', key: 'business' },
    { name: 'Layanan', path: '/services', key: 'services' },
    { name: 'Profil', path: '/profile', key: 'profile' },
    { name: 'Kontak', path: '/contact', key: 'contact' }
  ],
  ADMIN: [
    { name: 'Dashboard', path: '/admin', key: 'dashboard', icon: 'dashboard' },
    { name: 'Villa', path: '/admin/villas', key: 'villas', icon: 'home' },
    { name: 'Paket Bisnis', path: '/admin/business', key: 'business', icon: 'package' },
    { name: 'Layanan', path: '/admin/services', key: 'services', icon: 'service' },
    { name: 'Kontak', path: '/admin/contacts', key: 'contacts', icon: 'mail' },
    { name: 'Pengaturan', path: '/admin/settings', key: 'settings', icon: 'settings' }
  ]
};

// Toast Messages
export const TOAST_MESSAGES = {
  SUCCESS: {
    LOGIN: 'Login berhasil!',
    LOGOUT: 'Logout berhasil!',
    REGISTER: 'Registrasi berhasil!',
    UPDATE: 'Data berhasil diupdate!',
    CREATE: 'Data berhasil dibuat!',
    DELETE: 'Data berhasil dihapus!',
    UPLOAD: 'File berhasil diupload!',
    SEND: 'Pesan berhasil dikirim!'
  },
  ERROR: {
    LOGIN: 'Login gagal. Periksa email dan password Anda.',
    REGISTER: 'Registrasi gagal. Silakan coba lagi.',
    UPDATE: 'Gagal mengupdate data.',
    CREATE: 'Gagal membuat data.',
    DELETE: 'Gagal menghapus data.',
    UPLOAD: 'Gagal mengupload file.',
    SEND: 'Gagal mengirim pesan.',
    NETWORK: 'Terjadi kesalahan jaringan.',
    UNAUTHORIZED: 'Anda tidak memiliki akses.',
    NOT_FOUND: 'Data tidak ditemukan.',
    VALIDATION: 'Data yang dimasukkan tidak valid.',
    FILE_SIZE: 'Ukuran file terlalu besar.',
    FILE_TYPE: 'Tipe file tidak didukung.'
  },
  INFO: {
    LOADING: 'Sedang memproses...',
    NO_DATA: 'Tidak ada data tersedia.',
    CONFIRM_DELETE: 'Apakah Anda yakin ingin menghapus data ini?',
    UNSAVED_CHANGES: 'Ada perubahan yang belum disimpan.'
  }
};

// Social Media Platforms
export const SOCIAL_MEDIA = {
  FACEBOOK: 'facebook',
  INSTAGRAM: 'instagram',
  TWITTER: 'twitter',
  LINKEDIN: 'linkedin',
  YOUTUBE: 'youtube',
  WHATSAPP: 'whatsapp'
};

// Image Placeholder URLs
export const PLACEHOLDER_IMAGES = {
  VILLA: '/images/placeholder-villa.jpg',
  SERVICE: '/images/placeholder-service.jpg',
  USER: '/images/placeholder-user.jpg',
  COMPANY: '/images/placeholder-company.jpg'
};

// Map Configuration
export const MAP_CONFIG = {
  DEFAULT_CENTER: [-8.5069, 115.2625], // Ubud, Bali coordinates
  DEFAULT_ZOOM: 13,
  TILE_LAYER: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png'
};

// Error Codes
export const ERROR_CODES = {
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  VALIDATION_ERROR: 422,
  INTERNAL_SERVER_ERROR: 500
};

// Loading States
export const LOADING_STATES = {
  IDLE: 'idle',
  LOADING: 'loading',
  SUCCESS: 'success',
  ERROR: 'error'
};

// Screen Breakpoints (matching Tailwind CSS)
export const BREAKPOINTS = {
  SM: 640,
  MD: 768,
  LG: 1024,
  XL: 1280,
  XXL: 1536
};

export default {
  API_BASE_URL,
  API_ENDPOINTS,
  USER_ROLES,
  PROPERTY_STATUS,
  PACKAGE_TYPES,
  SERVICE_TYPES,
  CONTACT_STATUS,
  GENERAL_STATUS,
  PAGINATION,
  FILE_UPLOAD,
  VALIDATION,
  CURRENCY,
  DATE_FORMATS,
  STORAGE_KEYS,
  THEMES,
  LANGUAGES,
  MENU_ITEMS,
  TOAST_MESSAGES,
  SOCIAL_MEDIA,
  PLACEHOLDER_IMAGES,
  MAP_CONFIG,
  ERROR_CODES,
  LOADING_STATES,
  BREAKPOINTS
};